import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { ByzMuiDateTimePicker } from 'src/components/core-components/mui/inputs/ByzMuiDateTimePicker';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';
import ByzMuiTextField from 'src/components/core-components/mui/inputs/ByzMuiTextField';
import { useTranslate } from 'src/locales/use-locales';
import type { CapriniRiskAssessmentData } from '../models';

interface FormHeaderProps {
  formData: CapriniRiskAssessmentData;
  onFieldChange: (field: keyof CapriniRiskAssessmentData, value: string | number | Date | null) => void;
  extraAccess?: boolean;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  formData,
  onFieldChange,
  extraAccess,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <Grid
        md={6}
        sx={{
          backgroundColor: '#F4F7FE',
          borderBottom: '1px solid #E0E0E0',
          py: 1.5,
        }}
      >
        <ByzMuiTypography isTitle={true}>
          {t('caprini-risk-assessment.title')}
        </ByzMuiTypography>
      </Grid>

      {/* Tarih-Saat Alanı */}
      <Grid container alignItems="stretch" sx={{ minHeight: '64px' }}>
        <Grid
          xs={12}
          sm={6}
          md={6}
          sx={{
            borderBottom: '1px solid #E0E0E0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingLeft: '30px',
            paddingY: 2,
          }}
        >
          <ByzMuiTypography
            fontWeight={500}
            fontSize="14px"
            sx={{
              textAlign: 'left',
              width: '100%',
            }}
          >
            {t('datetime')}
          </ByzMuiTypography>
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            paddingY: 1,
            paddingX: 1,
          }}
        >
          <ByzMuiDateTimePicker
            sx={{ width: '100%' }}
            value={formData.PROCESS_TIME}
            onChange={(date) => onFieldChange('PROCESS_TIME', date)}
            disabled={!extraAccess}
          />
        </Grid>
      </Grid>

      {/* Kayıt Yapan Kullanıcı Alanı */}
      <Grid container alignItems="stretch" sx={{ minHeight: '64px' }}>
        <Grid
          xs={12}
          sm={6}
          md={6}
          sx={{
            borderBottom: '1px solid #E0E0E0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingLeft: '30px',
            paddingY: 2,
          }}
        >
          <ByzMuiTypography
            fontWeight={500}
            fontSize="14px"
            sx={{
              textAlign: 'left',
              width: '100%',
            }}
          >
            {t('createdby')}
          </ByzMuiTypography>
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            paddingY: 1,
            paddingX: 1,
          }}
        >
          <ByzMuiTextField
            sx={{ width: '100%' }}
            color="info"
            label={t('createdby')}
            variant="outlined"
            value={formData.CUSER || ''}
            onChange={(e) => onFieldChange('CUSER', e.target.value)}
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
};



